var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',[(_vm.isSelectionValid)?_c('v-rect',{ref:"boxSelection",attrs:{"config":_vm.config,"stroke-scale-enabled":false},on:{"dragend":_vm.onChange,"transformend":_vm.onChange}}):_vm._e(),_c('v-transformer',{ref:"boxTransformer",attrs:{"config":_vm.transformerConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }